import { useState, useEffect } from "react";
import styles from "./Contact.module.css";

function Contact() {
  const [email, setEmail] = useState(null);

  const [name, setName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [message, setMessage] = useState("");

  const [loadingEmail, setLoadingEmail] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const [sent, setSent] = useState(false);

  const [shakeName, setShakeName] = useState(false);
  const [shakeEmail, setShakeEmail] = useState(false);
  const [shakeMessage, setShakeMessage] = useState(false);

  const [lastRevealTime, setLastRevealTime] = useState(0);
  const [lastSendTime, setLastSendTime] = useState(0);
  const cooldown = 1000;

  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        Date.now() - lastRevealTime >= cooldown &&
        Date.now() - lastSendTime >= cooldown
      ) {
        clearInterval(interval);
      }
      setTick((t) => t + 1);
    }, 500);
    return () => clearInterval(interval);
  }, [lastRevealTime, lastSendTime]);

  useEffect(() => {
    const saved = localStorage.getItem("emailData");
    if (saved) {
      const { email, timestamp } = JSON.parse(saved);
      const now = Date.now();
      if (now - timestamp < 24 * 60 * 60 * 1000) {
        setEmail(email);
      } else {
        localStorage.removeItem("emailData");
      }
    }
  }, []);

  const revealEmail = async () => {
    if (Date.now() - lastRevealTime < cooldown) return;
    setLastRevealTime(Date.now());
    setLoadingEmail(true);
    try {
      const res = await fetch(
        "https://9p0y2mrynf.execute-api.eu-central-1.amazonaws.com/reveal-email"
      );
      const data = await res.json();
      setEmail(data.email);
      localStorage.setItem(
        "emailData",
        JSON.stringify({ email: data.email, timestamp: Date.now() })
      );
    } catch {
      setError("Failed to reveal email.");
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleSend = async () => {
    if (Date.now() - lastSendTime < cooldown) return;
    setLastSendTime(Date.now());

    setError(null);
    setSent(false);

    const invalidName = name.trim() === "";
    const invalidEmail = userEmail.trim() === "";
    const invalidMessage = message.trim() === "";

    if (invalidName) setShakeName(true);
    if (invalidEmail) setShakeEmail(true);
    if (invalidMessage) setShakeMessage(true);

    if (invalidName || invalidEmail || invalidMessage) {
      setTimeout(() => {
        setShakeName(false);
        setShakeEmail(false);
        setShakeMessage(false);
      }, 500);
      return;
    }

    setSending(true);
    try {
      const res = await fetch(
        "https://9p0y2mrynf.execute-api.eu-central-1.amazonaws.com/send-message",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name, email: userEmail, message }),
        }
      );
      if (!res.ok) throw new Error();
      setSent(true);
      setName("");
      setUserEmail("");
      setMessage("");
      setTimeout(() => setSent(false), 3000);
    } catch {
      setError("Failed to send message.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={styles.contact}>
      <div className={styles.left}>
        <div className={styles.eyebrow}>Contact</div>
        <h1>Get in touch</h1>
        <div className={styles.revealDiv}>
          {email ? (
            <a href={`mailto:${email}`}>{email}</a>
          ) : (
            <button
              type="button"
              onClick={revealEmail}
              className={styles.revealButton}
              disabled={loadingEmail || Date.now() - lastRevealTime < cooldown}
            >
              {loadingEmail ? "Revealing..." : "Reveal email"}
            </button>
          )}
        </div>
        <p>Feel free to get in touch, and I’ll respond as soon as possible.</p>
      </div>
      <div className={styles.right}>
        <div className={styles.nameEmailRow}>
          <input
            type="text"
            placeholder="Your name"
            className={`${styles.input} ${shakeName ? styles.shake : ""}`}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <input
            type="email"
            placeholder="Your email"
            className={`${styles.input} ${shakeEmail ? styles.shake : ""}`}
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
          />
        </div>
        <textarea
          placeholder="Message"
          className={`${styles.textarea} ${shakeMessage ? styles.shake : ""}`}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <div className={styles.sendDiv}>
          <button
            type="button"
            onClick={handleSend}
            disabled={sending || Date.now() - lastSendTime < cooldown}
          >
            {sending ? "Sending..." : "Send"}
          </button>
          {error && <div className={styles.error}>{error}</div>}
          {sent && (
            <div className={styles.success}>Message sent successfully!</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Contact;
